@if (showLdr) {
<ds-loading></ds-loading>
}

<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="visible"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="visible = false"
  class="dashbSlider"
>
  @if (selectedVehicle) {
  <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
  }
</nz-drawer>

<div class="row hdrBar">
  <div class="col-lg-6 col-md-6 mg-a">
    @if (clntDtls && clntDtls.length > 0) {
    <h1>
      {{ hdrLbl }} Dashboard - Clean Andhra Pradesh(CLAP) @if (selectedtenantNm)
      {
      <span class="tntTxt">({{ selectedtenantNm }})</span>
      }
    </h1>
    }
  </div>
  @if (tntLst.length>1) {
  <div class="col-lg-3 col-md-3 mg-a" style="text-align: right">
    <span>Select {{ hdrLbl }}:</span>
    <nz-select
      class="slctBx"
      nzShowSearch
      [(ngModel)]="selectedtenant"
      (ngModelChange)="ontntSelect($event)"
      [ngModelOptions]="{ standalone: true }"
    >
      <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
      @for (t of tntLst; track t) {
      <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_dsply_nm"></nz-option>
      }
    </nz-select>
  </div>
  } @if (tntLst.length==1) {
  <div class="col-lg-3 col-md-3 mg-a" style="text-align: right">
    <span>{{ hdrLbl }}:</span>
    <span class="disbledtxt">{{ tntLst[0].tnt_nm }}</span>
  </div>
  }
  <div class="col-lg-3 col-md-3 mg-a">
    <span>Select Date:</span>
    <nz-date-picker
      [nzDisabledDate]="disabledDate"
      [nzFormat]="dateFormat"
      [(ngModel)]="slctdDt"
      (ngModelChange)="onChange($event)"
    ></nz-date-picker>
  </div>
  <!-- <div class="col-lg-4 col-md-4 mg-a" style="text-align: right;">
  <span>Select Date:</span>
  <nz-date-picker   [nzDisabledDate]="disabledDate"   [nzFormat]="dateFormat" [(ngModel)]="slctdDt" (ngModelChange)="onChange($event)"></nz-date-picker>
</div> -->
</div>

<div class="main">
  <div class="row">
    <ul class="cards">
      @for (d of tdyCoveredTrips; track d) {
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #5b4785 0%, #3a347a 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Vehicles</h1>
            </div>
            <div class="row">
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ d.actv_veh_ct === null ? "0" : d.actv_veh_ct }}
                </h1>
                <h1 class="card_sub_title">Active</h1>
              </div>
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ d.inact_veh_cnt === null ? "0" : d.inact_veh_cnt }}
                </h1>
                <h1 class="card_sub_title">Spare</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      } @for (d of tdyCoveredTrips; track d) {
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #7f75e5 0%, #4e49b9 100%)"
          (click)="cardTwo()"
          [ngClass]="crdTwo == true ? 'active_class' : 'normalclass'"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Operational Status</h1>
            </div>
            <div class="row">
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ d.u_operated === null ? "0" : d.u_operated }}
                </h1>
                <h1 class="card_sub_title">Operated</h1>
              </div>
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ d.u_opper === null ? "0" : d.u_opper }} %
                </h1>
                <h1 class="card_sub_title">Operated %</h1>
              </div>
            </div>
            <div class="row">
              <p class="crdFtr">
                VEHICLES TRAVELLED > 500 Meters IS CONSIDERED AS OPERATED
              </p>
            </div>
          </div>
        </div>
      </li>
      } @for (d of ttlTrpsCnt; track d) {
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #288a63 0%, #267377 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Trips Travelled</h1>
            </div>
            <div class="row">
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ d.def_trps === null ? 0 : d.def_trps }}
                </h1>
                <h1 class="card_sub_title">Defined Trips</h1>
              </div>
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ d.tdy_trvl_trps === null ? 0 : d.tdy_trvl_trps }}
                </h1>
                <h1 class="card_sub_title">Travelled</h1>
              </div>
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ d.tdy_per === null ? 0 : d.tdy_per }}
                </h1>
                <h1 class="card_sub_title">Travelled %</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      }
    </ul>
  </div>

  <div class="row bg-w">
    <div class="col-lg-12 col-md-12">
      <h1>Operated Vehicles % in Last 7 Days</h1>
      <div id="distanceTavelledChart"></div>
    </div>
  </div>
  <div class="row bg-wp">
    <h1>Vehicles</h1>
    <div class="ds-card tbl grid">
      <app-data-grid
        class="p-8"
        style="width: 100%"
        [dataSource]="vehclesTble"
        [legacyColumns]="vehclesTblecolumnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="ulb wise operated Trips"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
      >
      </app-data-grid>
    </div>
  </div>

  <div class="row bg-wp">
    <h1>
      Last 10 Days Not-operated Vehicles<span
        >(Vehicles Travel Less than 2KMS)</span
      >
    </h1>
    <div id="lst10DysNtoprdTrpsChart"></div>
  </div>
</div>
